/* eslint-disable */
import React, { useEffect, useMemo, useState } from 'react';
import dayjs from 'dayjs';
import DataTable from '../../../../components/LynDataTable/DataTable';
import { Button, Spin, Tooltip } from 'antd';
import viewIcon from '../../../../assets/images/table-icons/view_blue.svg';
import { useSendControlDataMutation } from 'store/features/api/apiSlice';
import { useLocation } from 'react-router-dom';
import LeaseRecordViewModal from './CustomComponents/LeaseRecordViewModal';
import { Box } from '@mui/material';
import ConfirmModal from 'components/modal/ConfirmModal';
import Notification01Icon from 'assets/icons/notification01Icon';

export const formatNumber = (value, decimalPlaces = 2) => {
	// console.log(value, 'eyeViewData1122');
	// First check if value is null or undefined
	if (value === null || value === undefined) {
		return '0.00';
	}

	// Handle various input types
	const num = typeof value === 'string' ? parseFloat(value) : Number(value);

	// Check if the result is a valid number
	if (isNaN(num)) {
		return '0.00';
	}

	return num.toLocaleString('en-US', {
		minimumFractionDigits: decimalPlaces,
		maximumFractionDigits: decimalPlaces,
	});
};
const LeaseTable = ({
	leaseResponseData = [],
	screen = 'CREATE',
	identityData = {},
	initialFormValues = {},
	statusData = {},
	calculateData = {},
	viewData = {},
	form,
	// setFlag = () => {},
	setIsActionRequiredButtonClicked = () => {},
	leaseId = null,
}) => {
	const { state } = useLocation();

	// console.log('🚀 ~ leaseResponseData:', leaseResponseData);
	const [sendControlData, { data: checkResponseData }] = useSendControlDataMutation();
	const [showModal, setShowModal] = useState(false);
	const [actionRequiredData, setActionRequiredData] = useState({});
	const [actionRequiredConfirmModal, setActionRequiredConfirmModal] = useState(false);
	const [rowIndexColorMapping, setRowIndexColorMapping] = useState({});
	const [sendControlDataForJournal, { data: lynTaskDataForAccountingDocument }] = useSendControlDataMutation();
	// const reverseFormatNumber = (formattedValue) => {
	// 	// Remove all commas and parse the result as a float
	// 	return parseFloat(formattedValue.replace(/,/g, ''));
	// };
	const [tableUpperLeftExtraInfo, setTableUpperLeftExtraInfo] = useState({});

	const handleCheckButton = (data, index) => {
		setTableUpperLeftExtraInfo({
			leaseId: form.getFieldValue('leaseId'),

			leaseTitle: form.getFieldValue('leaseTitle'),
			// date: dayjs(data?.date).format('YYYY-MM-DD'),
			leasePeriod: data?.period,
		});
		let calculatedData = {};
		if (screen === 'CREATE') {
			calculatedData = calculateData;
		} else {
			calculatedData = {
				advanceAmount: initialFormValues?.advanceAmount,
				grossRent: statusData?.changes[0]?.inputChangeGrossAmount,
				leaseTerm: statusData?.changes[0]?.inputChangeLeaseTerm,
				discountRate: statusData?.changes[0]?.inputChangeDiscountRate,
				startYear: String(dayjs(statusData?.leaseStartDate).$y),
				escalation: statusData?.changes[0]?.inputChangeEscalation,
				startMonth: String(dayjs(statusData?.leaseStartDate).month() + 1),
				startDay: String(dayjs(statusData?.leaseStartDate).date()),
				paymentFrequency: statusData?.changes[0]?.paymentFrequency,
				paymentTime: statusData?.changes[0]?.paymentTime,
				advanceDuration: form.getFieldValue('advanceDuration'),

				changes: (form.getFieldValue('changes') ?? []).slice(1),
			};
		}
		const payloadData = {
			identityData,
			calculateData: calculatedData,
			scheduledIndex: index + 1,
		};

		const convertJson = JSON.stringify(payloadData);
		// console.log('🚀 ~ handleCheckButton ~ payloadData:', payloadData);
		const convertBase64 = btoa(convertJson);

		const formattedPayload = {
			data: convertBase64,
			processCode: state?.processCode,
			scriptName: 'lease-controller-schedule-findata2',
			payloadData: payloadData,
		};

		sendControlData(formattedPayload);
	};
	const handleActionRequiredButton = async () => {
		const data = actionRequiredData?.row?.original;

		const payloaddata = {
			id: data?._id,
		};
		const convertJson = JSON.stringify(payloaddata);
		const convertBase64 = btoa(convertJson);
		const formattedPayload = {
			data: convertBase64,
			processCode: state?.processCode,
			scriptName: 'lease-controller-schedule-ready',
			payloadData: payloaddata,
		};

		// if (processCode) {
		await sendControlDataForJournal(formattedPayload).then(() => {
			// setFlag((prev) => !prev);
			setIsActionRequiredButtonClicked(true);
		});
		// }
	};

	const columnData = useMemo(
		() => [
			{
				id: 'date',
				width: '5%',
				align: 'center',
				accessor: 'date',
				cellAlign: 'center',
				Header: 'Date',
			},
			{
				id: 'period',
				width: '5%',
				align: 'center',
				accessor: 'period',
				cellAlign: 'center',
				Header: 'Period',
			},
			{
				id: 'grossRent',
				width: '5%',
				align: 'center',
				accessor: 'grossRent',
				cellAlign: 'center',
				Header: 'Gross Rent',
			},
			{
				id: 'advanceAmount',
				width: '5%',
				align: 'center',
				accessor: 'advanceAmount',
				cellAlign: 'center',
				Header: 'Advance Amount',
			},
			{
				id: 'netPay',
				width: '5%',
				align: 'center',
				accessor: 'netPay',
				cellAlign: 'center',
				Header: 'Net pay',
			},
			{
				id: 'ibr',
				width: '5%',
				align: 'center',
				accessor: 'ibr',
				cellAlign: 'center',
				Header: 'IBR (%)',
			},
			{
				id: 'discountFactor',
				width: '5%',
				align: 'center',
				accessor: 'discountFactor',
				cellAlign: 'center',
				Header: 'Discount Factor',
			},
			{
				id: 'rentExp',
				width: '5%',
				align: 'center',
				accessor: 'rentExp',
				cellAlign: 'center',
				Header: 'PV of Rent',
			},

			{
				id: 'openLeaseLiability',
				width: '5%',
				align: 'right',
				accessor: 'openLeaseLiability',
				cellAlign: 'right',
				Header: 'Open Lease Liability',
			},
			{
				id: 'interestExp',
				width: '5%',
				align: 'right',
				accessor: 'interestExp',
				cellAlign: 'right',
				Header: 'Interest Expense',
			},

			{
				id: 'payment',
				width: '5%',
				align: 'right',
				accessor: 'payment',
				cellAlign: 'right',
				Header: 'Payment',
			},
			{
				id: 'closingLeaseLiability',
				width: '5%',
				align: 'right',
				accessor: 'closingLeaseLiability',
				cellAlign: 'right',
				Header: 'Closing Lease Liability',
			},
			{
				id: 'adjustment',
				width: '5%',
				align: 'right',
				accessor: 'adjustment',
				cellAlign: 'right',
				Header: 'Adjustment',
			},
			{
				Header: 'Action',
				Cell: (cell) => {
					// console.log('🚀 ~ cell?.row?.orginal?.processStatus?:', cell?.row?.original);
					return (
						<Box
							sx={{
								display: 'flex',
								justifyContent: cell?.row?.original?.processStatus?.toLowerCase() === 'returned' ? 'space-between' : 'center',
								alignItems: 'center',
							}}
						>
							<div style={{ textAlign: 'center' }}>
								<Tooltip title="Check">
									<Button
										type="text"
										icon={<img src={viewIcon} width={16} height={16} alt="view" />}
										onClick={(e) => {
											e.stopPropagation();

											handleCheckButton(cell?.row?.original, cell?.row?.index);
											setShowModal(true);
										}}
									></Button>
								</Tooltip>
							</div>
							{cell?.row?.original?.processStatus?.toLowerCase() === 'returned' && (
								<div style={{ textAlign: 'center' }}>
									<Tooltip title="Action Required">
										<Button
											type="text"
											icon={<Notification01Icon width={16} height={16} color="#B00020" />}
											onClick={(e) => {
												e.stopPropagation();

												setActionRequiredData(cell);
												setActionRequiredConfirmModal(true);
											}}
										></Button>
									</Tooltip>
								</div>
							)}
						</Box>
					);
				},
				disableSortBy: 'true',
				align: 'center',
			},
		],
		[]
	);
	const tableData = Array.isArray(leaseResponseData)
		? leaseResponseData?.map((item, index) => ({
				...item,
				date: dayjs(item.date).format('YYYY-MM-DD'),
				id: index,
				period: index + 1, // Setting period based on index (1-based)
				grossRent: formatNumber(item.grossRent, 2),
				discountFactor: formatNumber(item.discountFactor, 4),
				rentExp: formatNumber(item.rentExp, 2),
				interestExp: formatNumber(item.interestExp, 2),
				openLeaseLiability: formatNumber(item.openLeaseLiability, 2),
				interest: formatNumber(item.interest, 2),
				payment: formatNumber(item.payment, 2),
				closingLeaseLiability: formatNumber(item.closingLeaseLiability, 2),
				adjustment: formatNumber(item.adjustment, 2),
				advanceAmount: formatNumber(item.advanceAmount, 2),
				netPay: formatNumber(item.netPay, 2),
				ibr: formatNumber(item.ibr, 2),
			}))
		: [];
	const ModalData = {
		head: 'Returned Lease - Required Action',
	};
	useEffect(() => {
		// Define the color mapping for different processStatus values
		const statusColorMap = {
			Pending: '#E6F0FF', // light blue
			Unprocessed: '#E6F0FF', // light blue
			Reversed: '#E6F0FF', // light blue
			Returned: '#FFFDE6', // light yellow
			Recorded: '#E6FFE6', // light green
			Processed: '#E6F0FF', // light green
		};

		// Create a new mapping object
		const newMapping = {};

		// Loop through the leaseResponseData to populate the mapping
		leaseResponseData.forEach((lease, index) => {
			if (lease.processStatus) {
				newMapping[index] = {
					rowColor: statusColorMap[lease.processStatus] || '#FCFCFC',
				};
			}
		});

		// Update the state with the new mapping
		setRowIndexColorMapping(newMapping);
	}, [leaseResponseData]);

	return (
		<>
			<Spin spinning={screen !== 'CREATE' ? tableData?.length === 0 : false} style={{ maxHeight: '100%', marginTop: '20px' }}>
				{Array.isArray(tableData) && tableData?.length !== 0 && (
					<DataTable
						xlsxFileName={`${leaseId}_date`}
						COLUMNS={columnData || []}
						DATA={tableData || []}
						firstColStrick={false}
						pagination={false}
						onClickHandler={() => {}}
						rowIndexColorMapping={rowIndexColorMapping}
						pageSize={tableData.length}
					/>
				)}
			</Spin>
			{showModal && (
				<LeaseRecordViewModal
					showModal={showModal}
					setShowModal={setShowModal}
					checkResponseData={checkResponseData?.responseData || []}
					tableUpperLeftExtraInfo={tableUpperLeftExtraInfo}
					// isLoading={isScheduleLoading}
				/>
			)}
			{actionRequiredConfirmModal && (
				<ConfirmModal
					showModal={actionRequiredConfirmModal}
					setShowModal={setActionRequiredConfirmModal}
					// setSubmitForm={handleRecordModalSubmit}
					modalData={ModalData}
					handleSubmit={handleActionRequiredButton}
				/>
			)}
		</>
	);
};

export default LeaseTable;
